/** AutomationDashboardRoute — skin-aware switcher for /automations. */
import { useUISkin } from "@/data/UISkinContext";
import AutomationDashboard from "./AutomationDashboard";
import AutomationDashboardCockpit from "./AutomationDashboardCockpit";

export default function AutomationDashboardRoute() {
  const { skin } = useUISkin();
  if (skin === "cockpit") return <AutomationDashboardCockpit />;
  return <AutomationDashboard />;
}
